  <template>

  <div class="col-md-12">
    <div class="form-group">
      <input type="text" class="form-control" v-model="search" placeholder="Search">
    </div>

    <div class="table-responsive">
      <!--<table class="table table-striped table-bordered table-hover" style="width:100%">-->
      <table class="table table-hover" style="width:100%">
          <thead width="400px">
              <tr style="color:white"> <!--class="thead-light" -->
                  <th scope="col" style="color:black" >Product</th>
                  <th scope="col" class="col-xs-2 col-md-2" style="display:none;">Description</th>
                  <th scope="col" class="col-xs-2 col-md-2" style="color:black">Special Offer?</i></th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(list, index) in (sortedActivity, filteredList)" :key="list['.name']">
 
                <td>
                    <div class="wrapup"><p style="font-family:georgia,garamond,serif;color:black;font-size:16px">{{list.name}}</p></div>
                    <div class="pic-box">
                          <pic-zoom :url="list.photo" :scale="3" :show-eidt="false"></pic-zoom>
                    </div>
                    <p style="font-family:georgia,garamond,serif;color:blue;font-size:16px">{{list.currency}}{{list.price}}&nbsp
                        <b-btn @click="addItem(list)"  variant="outline-primary">
                            <i style="color:black" class="fas fa-cart-plus"></i>
                        </b-btn>
                            
                        <b-btn :id="'accordion-' + index" v-b-toggle="'col-' + index" variant="outline-primary">
                          <i style="color:black" class="fas fa-info-circle"></i>
                        </b-btn>   
                    </p>
                    <div>
                          <b-collapse :id="'col-' + index" class="mt-2">
                            <b-card>
                              <p class="card-text"><div class="wrapup"><p style="font-family:georgia,garamond,serif;color:black;font-size:14px">{{list.descr}}</p></div></p>
                            </b-card>
                          </b-collapse>
                    </div>
                </td>

                <td style="color:black">
                  <a v-if="list.special">
                    <span class="icon">
                        <i class="far fa-thumbs-up"></i>
                    </span>
                  </a>
 <!--                 <a v-else>
                    <span class="icon">
                        <i class="far fa-thumbs-down"></i>
                    </span>
                  </a>
-->                  
                </td>
              </tr>
          </tbody>
      </table>
    </div>
 

 <button @click="prevPage" class="float-left btn btn-outline-info btn-sm"><i class="fas fa-arrow-left"></i> Previous</button> 
 <button @click="nextPage" class="float-right btn btn-outline-info btn-sm">Next <i class="fas fa-arrow-right"></i></button>
  </div>
</template>

<script>
/*eslint-disable*/
import firebase from 'firebase'
import {db} from '../main'
import PicZoom from './PicZoom';
import {
  mapActions,
  mapGetters
} from 'vuex';

export default {
  name: 'product',
  components:{
    'PicZoom': PicZoom
  },
  props: ['category'],
  data: () => ({
    users: [],
    currentSort:'name',
    currentSortDir:'asc',
    search: '',
    searchSelection: '',
    pageSize: 5,
    currentPage: 1,
    lists: [],
    cartlabel: 'Add to cart',
    selectedImage:''
  }),
  computed: {
    
  },
  firestore () {
    return {lists: db.collection('products').where("category", "==", this.category)
    }
  },
  methods:{
    addItem(list) {
      const order = {
        item: Object.assign({},list ),
        quantity: 1,
        isAdd: true
      };
      //alert('You ordered: ' + order.item.name + '. Price: ' + order.item.currency + order.item.price + '. Qty: ' + order.quantity)
      //this.$store.commit("ADD_ITEM", order);  //commit the store, mutation is sync.
      this.$store.dispatch("ADD_ITEM",order);   //commit the mutation, action is async. ApI call action since async.
      
      let mycart = this.$store.getters.cartItemList  //can use ...mapGetters instead of getters to get the order items.
      //alert('CartItem: ' + mycart.item.name + '; Qty: ' + mycart.quantity)
    },
    addproduct: function(){
          this.$router.push('/addproduct') 
    },
    sort:function(s) {
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
    },
    nextPage:function() {
      if((this.currentPage*this.pageSize) < this.lists.length) this.currentPage++;
    },
    prevPage:function() {
      if(this.currentPage > 1) this.currentPage--;
    },
    zoomphoto:function(url) {
      //alert('Zoom the photo ' + url)
      this.selectedImage = url;
    }
  },

  computed: {
    sortedActivity:function() {
      return this.lists.sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      }).filter((row, index) => {
        let start = (this.currentPage-1)*this.pageSize;
        let end = this.currentPage*this.pageSize;
        if(index >= start && index < end) return true;
      });
    },

    filteredList () {
      return this.lists.filter((data) => {
        //alert('Search: ' + this.search.toLowerCase() + ' data: ' + data.category.toLowerCase());
        let name = data.name.toLowerCase().match(this.search.toLowerCase());
        let category = data.category.toLowerCase().match(this.search.toLowerCase());
        let descr = data.descr.toLowerCase().match(this.search.toLowerCase());
        let currency = data.currency.toLowerCase().match(this.search.toLowerCase());
        //alert('Search: ' + this.search.toLowerCase() + ' result: ' + channel);
        return name || category || descr || currency;
      }).filter((row, index) => {
        let start = (this.currentPage-1)*this.pageSize;
        let end = this.currentPage*this.pageSize;
        if(index >= start && index < end) return true;
      });
    }
  },

  mounted() {
    //alert('Category: ' + this.category)
  }

}
</script>

<style>
th {
  cursor:pointer;
  /* width: 500px !important; */
  white-space: nowrap;
}

tr {
  white-space: nowrap;
}

.wrapup {
    white-space: pre-wrap; /* css-3 */    
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */    
    white-space: -o-pre-wrap; /* Opera 7 */    
    word-wrap: break-word; width: 500px/* Internet Explorer 5.5+ */
   
}

//PicZoom
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  padding-bottom: 100px;
}
.pic-box{
  width:100px;
  height:150px;
  border:1px solid #eee;
}

</style>



// WEBPACK FOOTER //
// src/components/product.vue